var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/chip.css';
let Chip = class Chip extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = undefined;
        this.selected = undefined;
        this.version = '';
        this.text = '';
        this.type = 'default';
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    render() {
        var iconEl = html `<gs1-fa-icon family="fas" type="fa-times"></gs1-fa-icon>`;
        return html `
        ${env.debug ? html `<link rel="stylesheet" href="/css/chip.css" />` : html ``}
        
        ${this.version == 'input' ?
            html `<div class="chip chip-${this.type} ${this.version} ${this.disabled} ${this.selected}"><span>${this.text}</span>${iconEl}</div>` : html `
         <div class="chip chip-${this.type} ${this.version} ${this.disabled} ${this.selected}">${this.version == 'multiselect' ? html `<gs1-fa-icon family="fas" type="fa-check"></gs1-fa-icon>` : html ``}${this.text}</div>`}`;
    }
};
__decorate([
    property({ reflect: true })
], Chip.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], Chip.prototype, "selected", void 0);
__decorate([
    property()
], Chip.prototype, "version", void 0);
__decorate([
    property()
], Chip.prototype, "text", void 0);
__decorate([
    property()
], Chip.prototype, "type", void 0);
Chip = __decorate([
    customElement('gs1-chip')
], Chip);
export { Chip };
//# sourceMappingURL=chip.js.map